import styled from 'styled-components';

const FamilySiteWrap = styled.div`
  display: inline-block;
  width: 100%;
  position: relative;
  margin-bottom: 0.625rem;
`;

const FmailyBox = styled.div`
  height: 2.5rem;
  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    width: 10px;
    height: 1px;
    top: -webkit-calc(50% + 10px);
    top: calc(50% + 10px);
    right: 10.5px;
    margin-top: -1px;
    background-color: #999;
    z-index: 2;
  }
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    width: 1px;
    height: 10px;
    top: -webkit-calc(50% + 5px);
    top: calc(50% + 5px);
    right: 15px;
    margin-left: -px;
    background-color: #999;
    z-index: 1;
  }
`;

const SelectWrap = styled.select`
  cursor: pointer;
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 100%;
  height: 40px;
  height: 2.5rem;
  padding: 0 15px;
  padding: 0 0.9375rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 0.625rem;
  border: 0.1rem solid #e5e5e5;
  font-family: 'SDGothicNeobTTF-bLt';
  background-color: #fff;
  text-align: left;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 13px;
  font-size: 0.8125rem;
  color: #666;
  :focus {
  }
  :not(:-internal-list-box) {
    overflow: visible !important;
  }
`;

const SiteMap = () => {
  const move = e => {
    if (e.target?.value === 'DL이앤씨 e편한세상') {
      location.href = 'https://www.elife.co.kr/';
    } else if (e.target?.value === 'DL건설') {
      location.href = 'https://www.dlconstruction.co.kr/';
    }
  };

  return (
    <FamilySiteWrap>
      <FmailyBox>
        <SelectWrap onChange={move}>
          <option>Family Site</option>
          <option>DL이앤씨 e편한세상</option>
          <option>DL건설</option>
        </SelectWrap>
      </FmailyBox>
    </FamilySiteWrap>
  );
};

export default SiteMap;
